<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Confirmation Settings</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="460"
    fixed-header
    :headers="headers"
    :items="allConfirmationSettings"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-container row>
        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <!-- <v-btn v-if="showCreateBtn == true" v-show="confirmedBankAccountTypes" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedBankAccountTypes" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-if="confirmedBankAccountTypes" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-btn v-if="!confirmedBankAccountTypes" @click="confirmedBankAccountTypes = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn> -->
      </v-container>
    </template>

    <template v-slot:item.FunctionID="{ item }">
      {{allPermissions.filter(a => a.FunctionID == item.FunctionID).map(a => a.FunctionName)[0]}}
    </template>

    <template v-slot:item.Status="{ item }">
      <v-simple-checkbox
        v-model="item.Status"
      ></v-simple-checkbox>
    </template>

    <template v-slot:footer >
      <div class="text-right pa-4">
        <v-btn class="white--text" small color="#2A353D" @click="$router.push('/Home')">close</v-btn>
        <v-btn class="white--text ml-4" :disabled="showEditBtn != true" small color="#2A353D" @click="update()">
          <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
          save
        </v-btn>
      </div>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';

export default {

  data () {
    return {
      permitted: null,
      permitted_dialog: true,
      message: '',
      search: '',
      loading: false,
      valid: true,
      content: '',
      CurrentDataset: [],
      headers: [
        {
          text: 'Function',
          align: 'start',
          sortable: true,
          value: 'FunctionID'
        },
        { text: 'Is Confirmation Required', value: 'Status', sortable: false },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allPermissions",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings"
      ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3029).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3029).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3029).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3029).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },
  },

  methods: {
    ...mapActions([
      "updateConfirmationSettings",
    ]),

    update() {
      this.loading = true;
      this.message = '';
      var data = {
        load: this.allConfirmationSettings
      }

      this.updateConfirmationSettings(data)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updConfirmationSettings',
          data: this.allConfirmationSettings
        });
        this.message = response.data.message;
        this.loading = false;
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
      })
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    setActiveBankAccountType (item, index) {
      this.currentBankAccountType = item
      this.currentIndex = index
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },
  },

  mounted () {
    UserService.isConfirmationSettings().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
